export enum InputGroupType {
  InputGroupPrepend,
  InputGroupAppend,
}
